module.exports = __webpack_public_path__ + "assets/img/34_868_big.a286e79b.jpg";